import { render } from "./Questions.vue?vue&type=template&id=9c473ea8&scoped=true&ts=true"
import script from "./Questions.vue?vue&type=script&lang=ts"
export * from "./Questions.vue?vue&type=script&lang=ts"

import "./Questions.vue?vue&type=style&index=0&id=9c473ea8&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c473ea8"]])

export default __exports__